import { ArsContextState, IArsActionSetSidebarFilter } from "../interface";

/**
 * Sets the sidebar text filter.
 *
 * @param state - Current ARS context state
 * @param action - Set-sidebar-filter action
 * @returns Updated state with sidebar filter changed
 */
export const arsc_setSidebarFilter = <T>(
  state: ArsContextState<T>,
  action: IArsActionSetSidebarFilter,
): ArsContextState<T> => ({
  ...state,
  currentSidebar: {
    ...state.currentSidebar,
    filter: action.filter,
  },
});
